import { LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { HttpClient, HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';
import { NgbDateAdapter, NgbDateParserFormatter, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AppComponent } from './app.component';

import { AgGridModule } from 'ag-grid-angular';
import { HomeComponent } from './components/home/home.component';
import { NavMenuComponent } from './components/nav-menu/nav-menu.component';
import { TasacionEditComponent } from './components/tasacion-edit/tasacion-edit.component';
import { TasacionesComponent } from './components/tasaciones/tasaciones.component';

import { AdministracionEditComponent } from './components/administracion-edit/administracion-edit.component';
import { AdministracionComponent } from './components/administracion/administracion.component';
import { CellHyperlinkCustomComponent } from './components/cell-hyperlink-custom/cell-hyperlink-custom.component';
import { AdministrarService } from './services/administrar.service';
import { AuthService } from './services/auth.service';
import { TasacionesService } from './services/tasaciones.service';
import { UsuariosService } from './services/usuarios.service';

import { FileDropModule } from 'ngx-file-drop';
import { AgFileUploadComponent } from './components/ag-file-upload/ag-file-upload.component';
import { CellDateFormatterComponent } from './components/cell-date-formatter/cell-date-formatter.component';
import { ClientesEditComponent } from './components/clientes-edit/clientes-edit.component';
import { ClientesComponent } from './components/clientes/clientes.component';
import { ClientesService } from './services/clientes.service';
import { TipoInmuebleService } from './services/tipo-inmueble.service';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import {
  MatAutocompleteModule,
  MatButtonModule,
  MatCardModule,
  MatCheckboxModule,
  MatDialogModule,
  MatDividerModule,
  MatFormFieldModule, MatHorizontalStepper, MatIconModule,
  MatInputModule,
  MatProgressBarModule,
  MatRadioModule,
  MatSelectModule,
  MatSlideToggleModule,
  MatStepperModule,
  MatTabsModule,
  MatToolbarModule,
  MatTooltipModule
} from '@angular/material';

import { CellActionEventComponent } from './components/cell-actionevent/cell-actionevent.component';
import { ControlLookupComponent } from './components/control-lookup/control-lookup.component';
import { DashboardService } from './services/dashboard.service';
import { ImportarService } from './services/importar.service';
import { INMTasacionesService } from './services/inmtasaciones.service';
import { INMTestigosService } from './services/inmtestigos.service';

import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { LocalizationService } from './services/localization.service';

import { GooglePlaceModule } from 'ngx-google-places-autocomplete';
import { ContratosEditComponent } from './components/contratos-edit/contratos-edit.component';
import { ContratosComponent } from './components/contratos/contratos.component';
import { EntidadFinancieraEditComponent } from './components/entidad-financiera-edit/entidad-financiera-edit.component';
import { EntidadFinancieraComponent } from './components/entidad-financiera/entidad-financiera.component';
import { FileBrowserComponent } from './components/file-browser/file-browser.component';
import { FinalidadesEditComponent } from './components/finalidades-edit/finalidades-edit.component';
import { FinalidadesComponent } from './components/finalidades/finalidades.component';
import { IncidenciasEditComponent } from './components/incidencias-edit/incidencias-edit.component';
import { IncidenciasComponent } from './components/incidencias/incidencias.component';
import { TarifasEditComponent } from './components/tarifas-edit/tarifas-edit.component';
import { TarifasComponent } from './components/tarifas/tarifas.component';
import { ContratosService } from './services/contratos.service';

import { CurrencyMaskModule } from 'ng2-currency-mask';
import { CURRENCY_MASK_CONFIG, CurrencyMaskConfig } from 'ng2-currency-mask/src/currency-mask.config';
import { CellImageFormatterComponent } from './components/cell-image-formatter/cell-image-formatter.component';

import { AgmCoreModule } from '@agm/core';
import { CellUserStatisticsComponent } from './components/cell-user-statistics/cell-user-statistics.component';
import { DialogComponent } from './components/dialog/dialog.component';
import { FacturacionEditComponent } from './components/facturacion-edit/facturacion-edit.component';
import { FacturacionComponent } from './components/facturacion/facturacion.component';
import { ImportarComponent } from './components/importar/importar.component';
import { InmRelTasTestigoComponent } from './components/inm-rel-tas-testigo/inm-rel-tas-testigo.component';
import { INMTasacionesComponent } from './components/inmtasaciones/inmtasaciones.component';
import { INMTestigosComponent } from './components/inmtestigos/inmtestigos.component';
import { TarifaDetalleEditComponent } from './components/tarifa-detalle-edit/tarifa-detalle-edit.component';
import { TarifaDetalleComponent } from './components/tarifa-detalle/tarifa-detalle.component';
import { TestigosEditComponent } from './components/testigos-edit/testigos-edit.component';
import { TestigosComponent } from './components/testigos/testigos.component';
import { TipoContratoEditComponent } from './components/tipo-contrato-edit/tipo-contrato-edit.component';
import { TipoContratoComponent } from './components/tipo-contrato/tipo-contrato.component';
import { TipoInmmuebleComponent } from './components/tipo-inmmueble/tipo-inmmueble.component';
import { TipoInmuebleEditComponent } from './components/tipo-inmueble-edit/tipo-inmueble-edit.component';
import { ValidacionComponent } from './components/validacion/validacion.component';
import { DateHelper, DotNetDateAdapter, NgbDateCustomParserFormatter } from './models/NgDateCustomAdapter';
import { CurrencyFormatPipe } from './pipes/currency-format.pipe';
import { YesNoPipe } from './pipes/yesNo.pipe';
import { ValidacionService } from './services/validacion.service';


// importaciones para el uso de gestos en pantalla tactil
import { HAMMER_GESTURE_CONFIG } from '@angular/platform-browser';
import { MyHammerConfig } from './models/MyHammerConfig';

import { AngularMaterialModule } from './angular-material.module';

// Componentes cliente
import { CommonModule, registerLocaleData } from '@angular/common';
import { ToastrModule } from 'ngx-toastr';
import { AdministracionObjetivosEditComponent } from './components/administracion-objetivos-edit/administracion-objetivos-edit.component';
import { AdministracionObjetivosComponent } from './components/administracion-objetivos/administracion-objetivos.component';
import { CanalEntradaEditComponent } from './components/canal-entrada-edit/canal-entrada-edit.component';
import { CanalEntradaComponent } from './components/canal-entrada/canal-entrada.component';
import { HomeObjetivosComponent } from './components/home-objetivos/home-objetivos.component';
import { OficinaFacturacionEditComponent } from './components/oficina-facturacion-edit/oficina-facturacion-edit.component';
import { OficinaFacturacionComponent } from './components/oficina-facturacion/oficina-facturacion.component';
import { PrescriptorEditComponent } from './components/prescriptor-edit/prescriptor-edit.component';
import { PrescriptorComponent } from './components/prescriptor/prescriptor.component';
import { TecnicoEditComponent } from './components/tecnico-edit/tecnico-edit.component';
import { TecnicoComponent } from './components/tecnico/tecnico.component';
import { ValidacionEditComponent } from './components/validacion-edit/validacion-edit.component';
import { ValidadorEditComponent } from './components/validador-edit/validador-edit.component';
import { ValidadorComponent } from './components/validador/validador.component';
import { CheckFotosComponent } from './components/visitas-edit/check-fotos/check-fotos.component';
import { EstanciasEditComponent } from './components/visitas-edit/estancias-edit/estancias-edit.component';
import { EstanciasComponent } from './components/visitas-edit/estancias/estancias.component';
import { SelectMapDirectionComponent } from './components/visitas-edit/select-map-direction/select-map-direction.component';
import { VisitasEditComponent } from './components/visitas-edit/visitas-edit.component';
import { VisitasViewComponent } from './components/visitas-view/visitas-view.component';
import { VisitasComponent } from './components/visitas/visitas.component';
import { TapGestureDirective } from './models/Hammerjs';
import { AdministracionObjetivosService } from './services/administracion-objetivos.service';
import { CanalEntradaService } from './services/canal-entrada.service';
import { EstanciasService } from './services/estancias.service';
import { LocationService } from './services/location.service';
import { OficinaFacturacionService } from './services/oficina-facturacion.service';
import { PrescriptorService } from './services/prescriptor.service';
import { ValidacionEditService } from './services/validacion-edit.service';
import { VisitasService } from './services/visitas.service';
import { TasacionReclamacionEditComponent } from './components/tasacion-reclamacion-edit/tasacion-reclamacion-edit.component';
import { InformesDownloadComponent } from './components/informes-download/informes-download.component';
import { FileTemporalBrowserComponent } from './components/file-temporal-browser/file-temporal-browser.component';
import { AgUploadTemporalFilesComponent } from './components/ag-upload-temporal-files/ag-upload-temporal-files.component';
import { IncidenciaCloseComponent } from './components/incidencias-edit/incidencia-close/incidencia-close.component';
import { ReclamacionesComponent } from './components/reclamaciones/reclamaciones.component';
import { ReclamacionesEditComponent } from './components/reclamaciones-edit/reclamaciones-edit.component';
import { ModalDefaultComponent } from './components/controls/modal-default/modal-default.component';
import { DateAgo } from './pipes/timeAgo.pipe';
import localeEs from '@angular/common/locales/es';
import { FilterPipe } from './pipes/filter.pipe';
import { PsDatosGeneralesListComponent } from './components/proyectos-significativos/ps-datos-generales-list/ps-datos-generales-list.component';
import { PsDatosGeneralesEditComponent } from './components/proyectos-significativos/ps-datos-generales-edit/ps-datos-generales-edit.component';
import { PsAcuerdosBasicosEditComponent } from './components/proyectos-significativos/ps-acuerdos-basicos-edit/ps-acuerdos-basicos-edit.component';
import { PsAcuerdoPosteriorEditComponent } from './components/proyectos-significativos/ps-acuerdo-posterior-edit/ps-acuerdo-posterior-edit.component';
import { PsAcuerdosListComponent } from './components/proyectos-significativos/ps-acuerdos-list/ps-acuerdos-list.component';
import { PsTasacionListComponent } from './components/proyectos-significativos/ps-tasacion-list/ps-tasacion-list.component';
import { PsStatsComponent } from './components/proyectos-significativos/ps-stats/ps-stats.component';
import { PsReclamacionesIncidenciasComponent } from './components/proyectos-significativos/ps-reclamaciones-incidencias/ps-reclamaciones-incidencias.component';
import { PsRevisionComponent } from './components/proyectos-significativos/ps-revision/ps-revision.component';
import { TasacionEditPsFormComponent } from './components/tasacion-edit/tasacion-edit-ps-form/tasacion-edit-ps-form.component';
import { PsCoordinacionProyectoListComponent } from './components/proyectos-significativos/ps-coordinacion-proyecto-list/ps-coordinacion-proyecto-list.component';
import { PsCoordinacionProyectoEditComponent } from './components/proyectos-significativos/ps-coordinacion-proyecto-edit/ps-coordinacion-proyecto-edit.component';
import { PsRevisionFinComponent } from './components/proyectos-significativos/ps-revision-fin/ps-revision-fin.component';
import { PsAsignacionTasacionFormComponent } from './components/proyectos-significativos/ps-asignacion-tasacion-form/ps-asignacion-tasacion-form.component';
import { SelectorContactosComponent } from './components/selector-contactos/selector-contactos.component';
import { SelectorContactosEditComponent } from './components/selector-contactos-edit/selector-contactos-edit.component';
import { ContactosComponent } from './components/contactos/contactos.component';

registerLocaleData(localeEs, 'es');

// AoT requires an exported function for factories
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

export const CustomCurrencyMaskConfig: CurrencyMaskConfig = {
  align: 'left',
  allowNegative: true,
  decimal: ',',
  precision: 2,
  prefix: '',
  suffix: ' €',
  thousands: '.'
};

const appRoutes: Routes = [
  { path: '', component: HomeComponent, pathMatch: 'full' },
  { path: 'tasaciones', component: TasacionesComponent, canActivate: [AuthService] },
  { path: 'tasaciones/:idEstado', component: TasacionesComponent, canActivate: [AuthService] },
  {
    path: 'tasaciones-nuevas', component: TasacionesComponent, canActivate: [AuthService], data: {
      idEstadoFrom: 0,
      idEstadoTo: 100
    }
  },
  {
    path: 'tasaciones-tecnico', component: TasacionesComponent, canActivate: [AuthService], data: {
      idEstadoFrom: 300,
      idEstadoTo: 500
    }
  },
  {
    path: 'tasaciones-validar', component: TasacionesComponent, canActivate: [AuthService], data: {
      idEstadoFrom: 800,
      idEstadoTo: 900
    }
  },
  {
    path: 'tasaciones-entregadas', component: TasacionesComponent, canActivate: [AuthService], data: {
      idEstadoFrom: 910,
      idEstadoTo: 9999
    }
  },
  { path: 'crear-tasacion', component: TasacionEditComponent, canActivate: [AuthService] },
  { path: 'tasacion/edit/:id', component: TasacionEditComponent, canActivate: [AuthService] },
  { path: 'clientes', component: ClientesComponent, canActivate: [AuthService] },
  { path: 'clientes-create', component: ClientesEditComponent, canActivate: [AuthService] },
  { path: 'clientes/edit/:id', component: ClientesEditComponent, canActivate: [AuthService] },
  { path: 'administracion', component: AdministracionComponent, canActivate: [AuthService] },
  { path: 'administracion/edit/:id', component: AdministracionEditComponent, canActivate: [AuthService] },
  { path: 'administracion/create', component: AdministracionEditComponent, canActivate: [AuthService] },
  { path: 'finalidades', component: FinalidadesComponent, canActivate: [AuthService] },
  { path: 'finalidades/edit/:id', component: FinalidadesEditComponent, canActivate: [AuthService] },
  { path: 'tasacion/foto', component: AgFileUploadComponent, canActivate: [AuthService] },
  { path: 'entidadfinanciera', component: EntidadFinancieraComponent, canActivate: [AuthService] },
  { path: 'entidadfinanciera/edit/:id', component: EntidadFinancieraEditComponent, canActivate: [AuthService] },
  { path: 'incidencias-abiertas', component: IncidenciasComponent, canActivate: [AuthService], data: {estado: 'abiertas'} },
  { path: 'incidencias-cerradas', component: IncidenciasComponent, canActivate: [AuthService], data: {estado: 'cerradas'} },
  { path: 'incidencias-todas', component: IncidenciasComponent, canActivate: [AuthService], data: {estado: 'todas'} },
  { path: 'incidencias/create/:tasacion', component: IncidenciasEditComponent, canActivate: [AuthService] },
  { path: 'incidencias/edit/:id', component: IncidenciasEditComponent, canActivate: [AuthService] },
  { path: 'contratos', component: ContratosComponent, canActivate: [AuthService] },
  { path: 'contratos/edit/:id', component: ContratosEditComponent, canActivate: [AuthService] },
  { path: 'tarifas', component: TarifasComponent, canActivate: [AuthService] },
  { path: 'tarifas/edit/:id', component: TarifasEditComponent, canActivate: [AuthService] },
  { path: 'tarifa-create', component: TarifasEditComponent, canActivate: [AuthService] },
  { path: 'tarifaDetalle-create', component: TarifaDetalleEditComponent, canActivate: [AuthService] },
  { path: 'tarifaDetalle/edit/:id', component: TarifaDetalleEditComponent, canActivate: [AuthService] },
  { path: 'tipoinmuebles', component: TipoInmmuebleComponent, canActivate: [AuthService] },
  { path: 'tipoinmuebles/edit/:id', component: TipoInmuebleEditComponent, canActivate: [AuthService] },
  { path: 'importar', component: ImportarComponent, canActivate: [AuthService] },
  { path: 'inm-tasaciones', component: INMTasacionesComponent, canActivate: [AuthService] },
  { path: 'inm-testigos', component: INMTestigosComponent, canActivate: [AuthService] },
  { path: 'testigos', component: TestigosComponent, canActivate: [AuthService] },
  { path: 'testigos-edit', component: TestigosEditComponent, canActivate: [AuthService] },
  { path: 'rel-edit', component: InmRelTasTestigoComponent, canActivate: [AuthService] },
  { path: 'validacion-edit', component: ValidacionEditComponent, canActivate: [AuthService] },
  { path: 'visitas', component: VisitasComponent, canActivate: [AuthService] },
  { path: 'visita/:id/:version', component: VisitasEditComponent, canActivate: [AuthService] },
  { path: 'visita/:id/:version/:step', component: VisitasEditComponent, canActivate: [AuthService] },
  { path: 'visita/:id/:version/:step/:idEstancia', component: VisitasEditComponent, canActivate: [AuthService] },
  { path: 'oficinaFacturacion', component: OficinaFacturacionComponent, canActivate: [AuthService] },
  { path: 'oficinaFacturacion/:id', component: OficinaFacturacionEditComponent, canActivate: [AuthService] },
  { path: 'oficinaFacturacion/create', component: OficinaFacturacionEditComponent, canActivate: [AuthService] },
  { path: 'canalEntrada', component: CanalEntradaComponent, canActivate: [AuthService] },
  { path: 'canalEntrada/:id', component: CanalEntradaEditComponent, canActivate: [AuthService] },
  { path: 'canalEntrada/create', component: CanalEntradaEditComponent, canActivate: [AuthService] },
  { path: 'prescriptor', component: PrescriptorComponent, canActivate: [AuthService] },
  { path: 'prescriptor/:id', component: PrescriptorEditComponent, canActivate: [AuthService] },
  { path: 'prescriptor/create', component: PrescriptorEditComponent, canActivate: [AuthService] },
  { path: 'administracionObjetivos', component: AdministracionObjetivosComponent, canActivate: [AuthService] },
  { path: 'administracionObjetivos/:id', component: AdministracionObjetivosComponent, canActivate: [AuthService] },
  { path: 'administracionObjetivos/create', component: AdministracionObjetivosComponent, canActivate: [AuthService] },
  { path: 'validador', component: ValidadorComponent, canActivate: [AuthService] },
  { path: 'validador/:id', component: ValidadorEditComponent, canActivate: [AuthService] },
  { path: 'validador/create', component: ValidadorEditComponent, canActivate: [AuthService] },
  { path: 'tecnico', component: TecnicoComponent, canActivate: [AuthService] },
  { path: 'tecnico/:id', component: TecnicoEditComponent, canActivate: [AuthService] },
  { path: 'tecnicos/create', component: TecnicoEditComponent, canActivate: [AuthService] },
  { path: 'reclamacion/:id', component: TasacionReclamacionEditComponent, canActivate: [AuthService] },
  { path: 'incidencia/:id', component: IncidenciaCloseComponent, canActivate: [AuthService] },
  { path: 'informes', component: InformesDownloadComponent, canActivate: [AuthService] },
  { path: 'reclamaciones-abiertas', component: ReclamacionesComponent, canActivate: [AuthService], data: {estado: 'abiertas'} },
  { path: 'reclamaciones-cerradas', component: ReclamacionesComponent, canActivate: [AuthService], data: {estado: 'cerradas'} },
  { path: 'reclamaciones-todas', component: ReclamacionesComponent, canActivate: [AuthService], data: {estado: 'todas'} },
  { path: 'reclamaciones/create/:tasacion', component: ReclamacionesEditComponent, canActivate: [AuthService] },
  { path: 'reclamaciones/edit/:id', component: ReclamacionesEditComponent, canActivate: [AuthService] },
  { path: 'proyecto-significativo-list', component: PsDatosGeneralesListComponent, canActivate: [AuthService] },
  { path: 'proyecto-significativo/create', component: PsDatosGeneralesEditComponent, canActivate: [AuthService] },
  { path: 'proyecto-significativo/acuerdo-basico', component: PsAcuerdosBasicosEditComponent, canActivate: [AuthService] },
  { path: 'proyecto-significativo/acuerdo-posterior', component: PsAcuerdoPosteriorEditComponent, canActivate: [AuthService] },
  { path: 'proyecto-significativo/acuerdos', component: PsTasacionListComponent, canActivate: [AuthService] },
  { path: 'proyecto-significativo/edit/:id', component: PsDatosGeneralesEditComponent, canActivate: [AuthService] },
  { path: 'proyecto-significativo-stats', component: PsStatsComponent, canActivate: [AuthService] },
  { path: 'proyecto-significativo/reclamaciones-incidencias', component: PsReclamacionesIncidenciasComponent, canActivate: [AuthService] },
  { path: 'proyecto-significativo/revision', component: PsRevisionComponent, canActivate: [AuthService] },
  { path: '**', component: HomeComponent }

];

@NgModule({
  declarations: [
    AppComponent,
    NavMenuComponent,
    HomeComponent,
    TasacionesComponent,
    TasacionEditComponent,
    AdministracionComponent,
    AdministracionEditComponent,
    CellHyperlinkCustomComponent,
    AgFileUploadComponent,
    ClientesComponent,
    ClientesEditComponent,
    CellActionEventComponent,
    CellDateFormatterComponent,
    ControlLookupComponent,
    FinalidadesComponent,
    FinalidadesEditComponent,
    EntidadFinancieraComponent,
    EntidadFinancieraEditComponent,
    IncidenciasComponent,
    IncidenciasEditComponent,
    ContratosComponent,
    ContratosEditComponent,
    TarifasComponent,
    TarifasEditComponent,
    FileBrowserComponent,
    CellImageFormatterComponent,
    TipoContratoComponent,
    TipoInmmuebleComponent,
    TipoInmuebleEditComponent,
    TipoContratoEditComponent,
    TarifaDetalleComponent,
    DialogComponent,
    TarifaDetalleEditComponent,
    CellUserStatisticsComponent,
    FacturacionComponent,
    FacturacionEditComponent,
    ImportarComponent,
    INMTasacionesComponent,
    INMTestigosComponent,
    ValidacionComponent,
    TestigosEditComponent,
    TestigosComponent,
    InmRelTasTestigoComponent,
    VisitasComponent,
    VisitasEditComponent,
    SelectMapDirectionComponent,
    EstanciasComponent,
    EstanciasEditComponent,
    CheckFotosComponent,
    TapGestureDirective,
    ValidacionEditComponent,
    VisitasViewComponent,
    OficinaFacturacionComponent,
    OficinaFacturacionEditComponent,
    CanalEntradaComponent,
    CanalEntradaEditComponent,
    PrescriptorComponent,
    PrescriptorEditComponent,
    AdministracionObjetivosComponent,
    AdministracionObjetivosEditComponent,
    HomeObjetivosComponent,
    CurrencyFormatPipe,
    YesNoPipe,
    ValidadorComponent,
    FilterPipe,
    ValidadorEditComponent,
    TecnicoComponent,
    TecnicoEditComponent,
    TasacionReclamacionEditComponent,
    InformesDownloadComponent,
    FileTemporalBrowserComponent,
    AgUploadTemporalFilesComponent,
    IncidenciaCloseComponent,
    ReclamacionesComponent,
    ReclamacionesEditComponent,
    ModalDefaultComponent,
    DateAgo,
    PsDatosGeneralesListComponent,
    PsDatosGeneralesEditComponent,
    PsAcuerdosBasicosEditComponent,
    PsAcuerdoPosteriorEditComponent,
    PsAcuerdosListComponent,
    PsTasacionListComponent,
    PsStatsComponent,
    PsReclamacionesIncidenciasComponent,
    PsRevisionComponent,
    TasacionEditPsFormComponent,
    PsCoordinacionProyectoListComponent,
    PsCoordinacionProyectoEditComponent,
    PsRevisionFinComponent,
    PsAsignacionTasacionFormComponent,
    SelectorContactosComponent,
    SelectorContactosEditComponent,
    ContactosComponent
  ],
  entryComponents: [
    CellHyperlinkCustomComponent,
    CellActionEventComponent,
    CellDateFormatterComponent,
    CellImageFormatterComponent,
    DialogComponent,
    ModalDefaultComponent,
    CellUserStatisticsComponent,
    TasacionEditPsFormComponent,
    PsCoordinacionProyectoEditComponent,
    PsRevisionFinComponent,
    PsAsignacionTasacionFormComponent,
    SelectorContactosEditComponent,
    ContactosComponent
  ],
  exports: [
    AgFileUploadComponent,
    FileBrowserComponent,
    FileTemporalBrowserComponent,
    AgUploadTemporalFilesComponent
  ],
  imports: [
    BrowserModule.withServerTransition({ appId: 'ng-cli-universal' }),
    HttpClientModule,
    FormsModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    ReactiveFormsModule,
    AgGridModule.withComponents([]),
    RouterModule.forRoot(
      appRoutes
    ),
    FileDropModule,
    BrowserAnimationsModule,
    MatDialogModule,
    MatRadioModule,
    MatSelectModule,
    MatFormFieldModule,
    MatButtonModule, MatCheckboxModule, MatCardModule, MatInputModule, MatIconModule, MatDividerModule, MatStepperModule,
    MatToolbarModule, MatAutocompleteModule, MatTabsModule, MatSlideToggleModule, MatProgressBarModule, MatTooltipModule,
    GooglePlaceModule,
    CurrencyMaskModule,
    NgbModule,
    HttpClientModule,
    BrowserModule,
    AngularMaterialModule,
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyCyLV8rw7FbWTtHnITGpxhMm8KBnCTzWYs'
    }),
    CommonModule,
    BrowserAnimationsModule,
    ToastrModule.forRoot()
  ],
  providers: [
    AuthService,
    TasacionesService,
    UsuariosService,
    AdministrarService,
    ClientesService,
    DashboardService,
    LocalizationService,
    ContratosService,
    TipoInmuebleService,
    DateHelper,
    ImportarService,
    INMTasacionesService,
    INMTestigosService,
    ValidacionService,
    VisitasService,
    CanalEntradaService,
    OficinaFacturacionService,
    PrescriptorService,
    AdministracionObjetivosService,
    ValidacionEditService,
    EstanciasService,
    LocationService,
    { provide: LOCALE_ID, useValue: 'es'},
    { provide: CURRENCY_MASK_CONFIG, useValue: CustomCurrencyMaskConfig },
    { provide: NgbDateAdapter, useClass: DotNetDateAdapter },
    { provide: NgbDateParserFormatter, useClass: NgbDateCustomParserFormatter },
    {
      // para el uso de gestos en pantalla tactil
      provide: HAMMER_GESTURE_CONFIG,
      useClass: MyHammerConfig,
    },
    CurrencyFormatPipe,
    YesNoPipe
  ],
  bootstrap: [AppComponent]
})
export class AppModule {


}
